<div class="page-container">
  <section class="faq-section">
    <div class="faq-left">
      <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2c31aa98cac4b7b67b706_img_faq.avif" alt="FAQ" class="faq-image" />
      <app-apply-button></app-apply-button>
    </div>
    <div class="faq-right">
      <h1>Du hast Fragen?</h1>
      <h2 class="subtitle">WIR HABEN DIE ANTWORTEN</h2>
      
      <div class="faq-content">
        <!-- No FAQs Message -->
        <div class="no-faqs-container" *ngIf="faqItems.length === 0">
          <mat-icon>help_outline</mat-icon>
          <h2>Zurzeit gibt es keine FAQs</h2>
        </div>

        <mat-accordion *ngIf="faqItems.length > 0">
          <mat-expansion-panel *ngFor="let item of faqItems" class="faq-item">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ item.question }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{ item.answer }}</p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </section>


</div> 